import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  ScrollSectionViewport,
  ScrollSectionList,
  ScrollSectionListItem
} from '@brandwatch/scroll-section-list';

import { getState as getComponentPreloadState } from '../utils/preloadState';
import useRect from '../hooks/useRect';
import Slide from '../containers/Slide';
import SlideChaser from './SlideChaser/SlideChaser.jsx';

import './ScrollWrapper.css';

const noop = () => {};

const ScrollWrapper = ({
  name,
  slide_order = [],
  slideIndex = null,
  setSlideIndex = noop,
  focusMode = false
}) => {
  const activeId = slide_order.length && Number.isFinite(slideIndex) ? slideIndex : null;

  const onChange = useCallback((id) => {
    setSlideIndex(id);
  }, [setSlideIndex]);

  return (
    <div className={classNames('ScrollWrapper', {
      'ScrollWrapper--focusMode': focusMode
    })}>
      <div className="ScrollWrapper__header">
        <div className="ScrollWrapper__title">{name || '…'}</div>
      </div>
      <div className="ScrollWrapper__body">
        <ScrollSectionList
          onChange={onChange}
          activeId={activeId}
          smooth={false}
        >
          {
            slide_order.map((id, i) => {
              const distance = Math.abs(i - slideIndex);
              const preloadState = getComponentPreloadState(distance);

              return (
                <ScrollSectionListItem
                  key={id}
                  id={i}
                  index={i}
                >
                  {(isCurrent) => (
                    <div className="ScrollWrapper__item">
                      <Slide
                        id={id}
                        index={i}
                        distance={distance}
                        preloadState={preloadState}
                        isCurrent={isCurrent}
                      />
                    </div>
                  )}
                </ScrollSectionListItem>
              );
            })
          }
        </ScrollSectionList>
      </div>
      <div className="ScrollWrapper__footer">
        <SlideChaser />
      </div>
    </div>
  );
};

ScrollWrapper.propTypes = {
  slideIndex: PropTypes.number,
  slide_order: PropTypes.array,
  setSlideIndex: PropTypes.func,
  focusMode: PropTypes.bool
};

export default ScrollWrapper;
